/* START - Logic for Cart Delivery Options */
class CustomCartFulfillment {
  static instance = null;
  static _syncPromise = null;

  // Tracks whether a sync is in progress — checkout stays disabled until resolved
  _syncing = false;

  constructor(root = document) {
    this.root = root;

    this.FROZEN_MIN_WEIGHT = 19.99; // 0.01 lb buffer under the advertised 20 lb min
    this.FROZEN_ORDER_HANDLING_PRODUCT_ID = 9172286931197;
    this.FROZEN_ORDER_HANDLING_VARIANTS = [
      { min: 0,      max: 44.99,   variantId: 47280582459645,  label: '0 - 44.99 lbs (1x Cooler)' },
      { min: 45,     max: 89.99,   variantId: 47280582492413,  label: '45 - 89.99 lbs (2x Coolers)' },
      { min: 90,     max: 134.99,  variantId: 47280582525181,  label: '90 - 134.99 lbs (3x Coolers)' },
      { min: 135,    max: 179.99,  variantId: 47280582557949,  label: '135 - 179.99 lbs (4x Coolers)' },
      { min: 180,    max: 224.99,  variantId: 47280582590717,  label: '180 - 224.99 lbs (5x Coolers)' },
      { min: 225,    max: 269.99,  variantId: 47379644154109,  label: '225 - 269.99 lbs (6x Coolers)' },
      { min: 270,    max: 314.99,  variantId: 47379644186877,  label: '270 - 314.99 lbs (7x Coolers)' },
      { min: 315,    max: 359.99,  variantId: 47379644219645,  label: '315 - 359.99 lbs (8x Coolers)' },
      { min: 360,    max: 404.99,  variantId: 47379644252413,  label: '360 - 404.99 lbs (9x Coolers)' },
      { min: 405,    max: 449.99,  variantId: 47379644285181,  label: '405 - 449.99 lbs (10x Coolers)' },
      { min: 450,    max: 494.99,  variantId: 47379644317949,  label: '450 - 494.99 lbs (11x Coolers)' },
      { min: 495,    max: 539.99,  variantId: 47379644350717,  label: '495 - 539.99 lbs (12x Coolers)' },
      { min: 540,    max: 584.99,  variantId: 47379644383485,  label: '540 - 584.99 lbs (13x Coolers)' },
      { min: 585,    max: 629.99,  variantId: 47379644416253,  label: '585 - 629.99 lbs (14x Coolers)' },
      { min: 630,    max: 674.99,  variantId: 47379644449021,  label: '630 - 674.99 lbs (15x Coolers)' },
      { min: 675,    max: Infinity, variantId: 47379644481789,  label: '675+ lbs (15+ Coolers)' },
    ];

    this.ROUTE_DELIVERY_PRODUCT_ID = 9212866101501;
    this.ROUTE_DELIVERY_VARIANT_ID = 47363861479677;

    this.STORE_PICKUP_ADDRESS = {
      company: 'Store Pickup Order',
      address1: '900 S Main Street',
      city: 'Springfield',
      province: 'Tennessee',
      country: 'United States',
      zip: '37172',
      phone: '+16154551849',
    };

    this.routes = [];

    // Cache for route selections when user switches away
    this._cachedRouteSelection = null;

    this.queryElements();
    if (!this.container) return;

    this.parseRoutes();
    this.bindEvents();
    this.restoreSavedState();
    this.initMethodState();

    CustomCartFulfillment.instance = this;
  }

  queryElements() {
    this.container = this.root.querySelector('#CustomCartFulfillment');
    if (!this.container) return;

    this.routesEl = this.root.querySelector('#CustomCartDeliveryRoutesData');
    this.methodInputs = this.container.querySelectorAll('input[name="custom_delivery_method"]');
    this.routeFields = this.root.querySelector('#CustomCartRouteFields');
    this.routeSelect = this.root.querySelector('#CustomCartRouteSelect');
    this.stopWrap = this.root.querySelector('#CustomCartStopWrap');
    this.stopSelect = this.root.querySelector('#CustomCartStopSelect');
    this.dateWrap = this.root.querySelector('#CustomCartDateWrap');
    this.dateSelect = this.root.querySelector('#CustomCartDateSelect');
    this.routeDescription = this.root.querySelector('#CustomCartRouteDescription');
    this.stopReflection = this.root.querySelector('#CustomCartStopReflection');
    this.dateReflection = this.root.querySelector('#CustomCartDateReflection');
    this.routeMessage = this.root.querySelector('#CustomCartRouteMessage');
    this.routeDetailsContainer = this.root.querySelector('#CartRouteDetailsInline');
    this.routeDetailsTitle = this.root.querySelector('#CartRouteDetailsTitle');
    this.routeDetailsInline = this.root.querySelector('#CartRouteDetailsContent');
    this.bundleFields = this.root.querySelector('#CustomCartBundleFields');
    this.bundleOrderInput = this.root.querySelector('#CustomCartBundleOrderInput');
    this.bundleEmailInput = this.root.querySelector('#CustomCartBundleEmailInput');
    this.bundleMessage = this.root.querySelector('#CustomCartBundleMessage');
    this.checkoutBtn = this.root.querySelector('button[name="checkout"][form="cart"]');
  }

  parseRoutes() {
    try {
      this.routes = JSON.parse(this.routesEl?.textContent || '[]');
    } catch (e) { /* invalid route data */ }
  }

  refresh() {
    this.queryElements();
    if (!this.container) return;

    this.parseRoutes();
    this.bindEvents();
    this.restoreSavedState();
    this.initMethodState();
  }

  restoreSavedState() {
    const savedRoute = this.container.dataset.savedRoute || '';
    const savedStop = this.container.dataset.savedStop || '';
    const savedDate = this.container.dataset.savedDate || '';

    if (!savedRoute || !this.routeSelect) return;

    const selectedRoute = this.routes.find((r) => r.name === savedRoute);
    if (!selectedRoute) return;

    this.updateRouteDescription(selectedRoute);

    this.stopSelect.innerHTML = '<option value="">Choose a stop</option>';
    (selectedRoute.stops || []).forEach((stop) => {
      const option = document.createElement('option');
      option.value = stop.label;
      option.textContent = stop.label;
      if (stop.label === savedStop) option.selected = true;
      this.stopSelect.appendChild(option);
    });

    this.dateSelect.innerHTML = '<option value="">Choose a date</option>';
    this.filterFutureDates(selectedRoute.dates).forEach((date) => {
      const option = document.createElement('option');
      option.value = date;
      option.textContent = this.formatDate(date);
      if (date === savedDate) option.selected = true;
      this.dateSelect.appendChild(option);
    });

    this.stopWrap.hidden = false;
    this.dateWrap.hidden = false;
    this.updateReflections();

    if (savedRoute) {
      this._cachedRouteSelection = {
        route: savedRoute,
        stop: savedStop,
        date: savedDate,
      };
    }
  }

  bindEvents() {
    this.methodInputs.forEach((input) => {
      input.addEventListener('change', this.handleMethodChange.bind(this));
    });

    this.routeSelect?.addEventListener('change', this.handleRouteChange.bind(this));
    this.stopSelect?.addEventListener('change', this.handleRouteStopDateChange.bind(this));
    this.dateSelect?.addEventListener('change', this.handleRouteStopDateChange.bind(this));

    [this.bundleOrderInput, this.bundleEmailInput].forEach((input) => {
      if (!input) return;
      input.addEventListener('input', () => this.setCheckoutState());
      input.addEventListener('change', this.handleBundleFieldChange.bind(this));
    });

    const cartForm = document.querySelector('#cart');
    if (cartForm && !cartForm.dataset.fulfillmentBound) {
      cartForm.dataset.fulfillmentBound = 'true';
      cartForm.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  /* ========================================================
     GETTERS
  ======================================================== */

  getSelectedMethod() {
    return this.container.querySelector('input[name="custom_delivery_method"]:checked')?.value || '';
  }

  getFrozenWeight() {
    const tracker = this.root.querySelector('[data-frozen-tracker]');
    return Number(tracker?.dataset.frozenWeight || 0);
  }

  hasFrozenItems() {
    const tracker = this.root.querySelector('[data-frozen-tracker]');
    return tracker?.dataset.hasFrozen === 'true';
  }

  getDeliveryMethodAttributeValue() {
    const method = this.getSelectedMethod();
    if (method === 'Shipping') {
      return this.hasFrozenItems() ? 'Frozen Shipping' : 'Standard Shipping';
    }
    return method || '';
  }

  isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
  }

  buildCheckoutUrlWithShippingAddress(address) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(address)) {
      if (value) params.append(`checkout[shipping_address][${key}]`, value);
    }
    return `/checkout?${params.toString()}`;
  }

  /* ========================================================
     TRACKER VISIBILITY
  ======================================================== */

  hideTracker() {
    const tracker = this.root.querySelector('[data-frozen-tracker]');
    if (tracker) tracker.classList.add('frozen-tracker--collapsed');
  }

  showTrackerIfNeeded() {
    const tracker = this.root.querySelector('[data-frozen-tracker]');
    if (!tracker) return;

    const method = this.getSelectedMethod();
    const shouldShow = method === 'Shipping' && this.hasFrozenItems();

    tracker.classList.toggle('frozen-tracker--collapsed', !shouldShow);
  }

  /* ========================================================
     ROUTE SELECTION CACHE
  ======================================================== */

  cacheRouteSelection() {
    const route = this.routeSelect?.value || '';
    const stop = this.stopSelect?.value || '';
    const date = this.dateSelect?.value || '';

    if (route) {
      this._cachedRouteSelection = { route, stop, date };
    }
  }

  restoreCachedRouteSelection() {
    if (!this._cachedRouteSelection || !this.routeSelect) return;

    const { route, stop, date } = this._cachedRouteSelection;

    this.routeSelect.value = route;

    const selectedRoute = this.routes.find((r) => r.name === route);
    if (!selectedRoute) return;

    this.updateRouteDescription(selectedRoute);

    this.stopSelect.innerHTML = '<option value="">Choose a stop</option>';
    (selectedRoute.stops || []).forEach((s) => {
      const option = document.createElement('option');
      option.value = s.label;
      option.textContent = s.label;
      if (s.label === stop) option.selected = true;
      this.stopSelect.appendChild(option);
    });

    this.dateSelect.innerHTML = '<option value="">Choose a date</option>';
    this.filterFutureDates(selectedRoute.dates).forEach((d) => {
      const option = document.createElement('option');
      option.value = d;
      option.textContent = this.formatDate(d);
      if (d === date) option.selected = true;
      this.dateSelect.appendChild(option);
    });

    this.stopWrap.hidden = false;
    this.dateWrap.hidden = false;
    this.updateReflections();
  }

  /* ========================================================
     ROUTE HELPERS
  ======================================================== */

  clearRouteFields() {
    if (this.routeSelect) this.routeSelect.value = '';
    if (this.stopSelect) this.stopSelect.innerHTML = '<option value="">Choose a stop</option>';
    if (this.dateSelect) this.dateSelect.innerHTML = '<option value="">Choose a date</option>';
    if (this.stopWrap) this.stopWrap.hidden = true;
    if (this.dateWrap) this.dateWrap.hidden = true;
    this.updateRouteDescription(null);
    this.updateReflections();
  }

  setReflection(el, text) {
    if (!el) return;
    const span = el.querySelector('span');
    if (text) {
      if (span) span.textContent = text;
      el.classList.add('reflection--visible');
    } else {
      el.classList.remove('reflection--visible');
      // Clear text after transition
      if (span) setTimeout(() => { if (!el.classList.contains('reflection--visible')) span.textContent = ''; }, 250);
    }
  }

  updateRouteDescription(selectedRoute) {
    if (!this.routeDescription) return;
    if (!selectedRoute) {
      this.setReflection(this.routeDescription, '');
      return;
    }
    const parts = [selectedRoute.name];
    if (selectedRoute.description) parts.push(selectedRoute.description);
    this.setReflection(this.routeDescription, parts.join(' — '));
  }

  updateReflections() {
    this.setReflection(this.stopReflection, this.stopSelect?.value || '');
    const dateVal = this.dateSelect?.value || '';
    this.setReflection(this.dateReflection, dateVal ? this.formatDate(dateVal) : '');
  }

  formatDate(dateString) {
    const date = new Date(`${dateString}T12:00:00`);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }

  filterFutureDates(dates) {
    const today = new Date().toISOString().slice(0, 10);
    return (dates || []).filter((d) => d >= today).sort();
  }

  getRouteProperties() {
    const route = this.routeSelect?.value || '';
    const stop = this.stopSelect?.value || '';
    const date = this.dateSelect?.value || '';
    const properties = {};
    if (route) properties['Route'] = route;
    if (stop) properties['Stop'] = stop;
    if (date) properties['Date'] = date;
    return properties;
  }

  getSelectedStop() {
    const selectedRoute = this.routes.find((r) => r.name === this.routeSelect?.value);
    if (!selectedRoute) return null;
    return (selectedRoute.stops || []).find((s) => s.label === this.stopSelect?.value) || null;
  }

  async updateRouteDeliveryProperties() {
    try {
      const cart = await this.fetchCart();
      const feeItem = cart.items.find(
        (item) => item.product_id === this.ROUTE_DELIVERY_PRODUCT_ID
      );
      if (!feeItem) return;

      const properties = this.getRouteProperties();

      await fetch(`${FoxTheme.routes.cart_change_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({ id: feeItem.key, quantity: 1, properties }),
      });
    } catch (e) { /* property update failed silently */ }
  }

  /* ========================================================
     CART API HELPERS
  ======================================================== */

  getFrozenHandlingTier(weight) {
    return this.FROZEN_ORDER_HANDLING_VARIANTS.find(
      (tier) => weight >= tier.min && weight <= tier.max
    ) || null;
  }

  async fetchCart() {
    const res = await fetch(`${FoxTheme.routes.cart_url}.js`, {
      ...FoxTheme.utils.fetchConfig(),
    });
    return res.json();
  }

  async updateCartAttributes(attributes) {
    return fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      body: JSON.stringify({ attributes }),
    });
  }

  /* ========================================================
     CART PAGE REFRESH
  ======================================================== */

  async refreshCartPage() {
    try {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      if (sectionsToBundle.length === 0) {
        const mainCart = this.root.querySelector('[id^="MainCart-"]');
        if (mainCart) {
          const sectionId = mainCart.id.replace('MainCart-', '');
          sectionsToBundle.push(sectionId);
        }
      }

      const response = await fetch(FoxTheme.routes.cart_update_url, {
        ...FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({
          sections: sectionsToBundle,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error('Cart update request failed');

      const cartData = await response.json();

      FoxTheme.pubsub.publish(
        FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        { cart: cartData }
      );
    } catch (e) { /* refresh failed silently */ }
  }

  /* ========================================================
     FROZEN HANDLING — SYNC (mutex)
  ======================================================== */

  async syncFrozenHandlingItem(cart) {
    if (CustomCartFulfillment._syncPromise) {
      return CustomCartFulfillment._syncPromise;
    }

    CustomCartFulfillment._syncPromise = this._performFrozenSync(cart);

    try {
      return await CustomCartFulfillment._syncPromise;
    } finally {
      CustomCartFulfillment._syncPromise = null;
    }
  }

  /* ========================================================
     FROZEN HANDLING — SYNC (logic)
  ======================================================== */

  async _performFrozenSync(cart) {
    const method = this.getSelectedMethod();
    const frozenWeight = this.getFrozenWeight();
    const hasFrozen = this.hasFrozenItems();

    const needsHandling = method === 'Shipping' && hasFrozen && frozenWeight > 0;
    const targetTier = needsHandling ? this.getFrozenHandlingTier(frozenWeight) : null;

    try {
      const handlingItems = cart.items.filter(
        (item) => item.product_id === this.FROZEN_ORDER_HANDLING_PRODUCT_ID
      );

      if (!targetTier) {
        if (handlingItems.length === 0) return false;

        for (const item of handlingItems) {
          await fetch(`${FoxTheme.routes.cart_change_url}`, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
        }
        return true;
      }

      const weightLabel = `${frozenWeight.toFixed(2)}lbs`;
      const correctItem = handlingItems.find(
        (item) => item.variant_id === targetTier.variantId
      );
      if (correctItem && handlingItems.length === 1 && correctItem.quantity === 1
        && correctItem.properties?.['Total Frozen Weight'] === weightLabel) {
        return false;
      }

      if (handlingItems.length > 0) {
        for (const item of handlingItems) {
          await fetch(`${FoxTheme.routes.cart_change_url}`, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
        }
      }

      const addRes = await fetch(`${FoxTheme.routes.cart_add_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({
          items: [{ id: targetTier.variantId, quantity: 1, properties: { 'Total Frozen Weight': weightLabel } }],
        }),
      });

      const addData = await addRes.json();
      if (addData.status) return false;

      return true;
    } catch (e) {
      return false;
    }
  }

  /* ========================================================
     ROUTE DELIVERY FEE — SYNC
  ======================================================== */

  async syncRouteDeliveryItem(cart) {
    const method = this.getSelectedMethod();
    const needsFee = method === 'Local Route Delivery';

    try {
      const feeItems = cart.items.filter(
        (item) => item.product_id === this.ROUTE_DELIVERY_PRODUCT_ID
      );

      if (!needsFee) {
        if (feeItems.length === 0) return false;

        for (const item of feeItems) {
          await fetch(`${FoxTheme.routes.cart_change_url}`, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
        }
        return true;
      }

      if (feeItems.length === 1 && feeItems[0].variant_id === this.ROUTE_DELIVERY_VARIANT_ID && feeItems[0].quantity === 1) {
        return false;
      }

      if (feeItems.length > 0) {
        for (const item of feeItems) {
          await fetch(`${FoxTheme.routes.cart_change_url}`, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
        }
      }

      const properties = this.getRouteProperties();
      const addRes = await fetch(`${FoxTheme.routes.cart_add_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({
          items: [{ id: this.ROUTE_DELIVERY_VARIANT_ID, quantity: 1, properties }],
        }),
      });

      const addData = await addRes.json();
      if (addData.status) return false;

      return true;
    } catch (e) {
      return false;
    }
  }

  hasRealItems(cart) {
    return cart.items.some(
      (item) => item.product_id !== this.FROZEN_ORDER_HANDLING_PRODUCT_ID
        && item.product_id !== this.ROUTE_DELIVERY_PRODUCT_ID
    );
  }

  setFeeItemLoading(loading) {
    this.root.querySelectorAll('.cart-item--auto-fee').forEach((row) => {
      row.classList.toggle('cart-item--fee-loading', loading);
      if (loading && !row.querySelector('.cart-item__fee-spinner')) {
        const spinner = document.createElement('div');
        spinner.className = 'cart-item__fee-spinner';
        spinner.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle></svg>';
        row.appendChild(spinner);
      } else if (!loading) {
        row.querySelector('.cart-item__fee-spinner')?.remove();
      }
    });
  }

  async runSyncsAndRefresh({ showLoading = false } = {}) {
    this._syncing = true;
    if (showLoading) {
      this.setCheckoutDisplay('loading');
      this.setFeeItemLoading(true);
    } else {
      this.setCheckoutState();
    }

    try {
      const cart = await this.fetchCart();

      // If the cart only has fee items and no real products, remove all fees
      if (!this.hasRealItems(cart)) {
        const feeItems = cart.items.filter(
          (item) => item.product_id === this.FROZEN_ORDER_HANDLING_PRODUCT_ID
            || item.product_id === this.ROUTE_DELIVERY_PRODUCT_ID
        );
        if (feeItems.length > 0) {
          for (const item of feeItems) {
            await fetch(`${FoxTheme.routes.cart_change_url}`, {
              ...FoxTheme.utils.fetchConfig(),
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            });
          }
          await this.refreshCartPage();
        }
        return;
      }

      const method = this.getSelectedMethod();
      const frozenWeight = this.getFrozenWeight();
      const hasFrozen = this.hasFrozenItems();
      const needsFrozen = method === 'Shipping' && hasFrozen && frozenWeight > 0;
      const needsRoute = method === 'Local Route Delivery';

      // Step 1: Remove items that shouldn't be in cart (in parallel)
      const removals = [];
      if (!needsFrozen) {
        const frozenItems = cart.items.filter(i => i.product_id === this.FROZEN_ORDER_HANDLING_PRODUCT_ID);
        for (const item of frozenItems) {
          removals.push(fetch(`${FoxTheme.routes.cart_change_url}`, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          }));
        }
      }
      if (!needsRoute) {
        const routeItems = cart.items.filter(i => i.product_id === this.ROUTE_DELIVERY_PRODUCT_ID);
        for (const item of routeItems) {
          removals.push(fetch(`${FoxTheme.routes.cart_change_url}`, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          }));
        }
      }
      if (removals.length > 0) await Promise.all(removals);

      // Step 2: Refetch cart after removals, then add what's needed
      const freshCart = removals.length > 0 ? await this.fetchCart() : cart;

      const [frozenChanged, routeChanged] = await Promise.all([
        needsFrozen ? this.syncFrozenHandlingItem(freshCart) : Promise.resolve(false),
        needsRoute ? this.syncRouteDeliveryItem(freshCart) : Promise.resolve(false),
      ]);

      // Refresh the disambiguated Delivery Method cart attribute (e.g. flip
      // 'Standard Shipping' <-> 'Shipping' as frozen items come and go) so the
      // checkout customization always sees the current state.
      await this.updateCartAttributes({ 'Delivery Method': this.getDeliveryMethodAttributeValue() });

      if (frozenChanged || routeChanged || removals.length > 0) {
        await this.refreshCartPage();
      }
    } finally {
      this._syncing = false;
      if (showLoading) this.setFeeItemLoading(false);
      this.showTrackerIfNeeded();
      this.setCheckoutState();
    }
  }

  /* ========================================================
     INIT & STATE
  ======================================================== */

  async initMethodState() {
    const method = this.getSelectedMethod();

    if (method === 'Local Route Delivery') {
      this.routeFields.classList.remove('route-fields--collapsed');
    } else {
      this.routeFields.classList.add('route-fields--collapsed');
      this.clearRouteFields();
      this.updateRouteDetailsInline();
    }

    // Sync without hiding existing visible elements — no flicker on qty changes
    await this.runSyncsAndRefresh();
  }

  ensureCheckoutSpinner() {
    if (!this.checkoutBtn || this.checkoutBtn.querySelector('.loading__spinner')) return;
    const spinner = document.createElement('div');
    spinner.className = 'loading__spinner';
    spinner.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle></svg>';
    this.checkoutBtn.appendChild(spinner);
  }

  // state: 'loading' | 'disabled' | 'enabled'
  setCheckoutDisplay(state, label) {
    if (!this.checkoutBtn) return;
    this.ensureCheckoutSpinner();
    const textEl = this.checkoutBtn.querySelector('.btn__text');

    if (state === 'loading') {
      this.checkoutBtn.disabled = true;
      this.checkoutBtn.classList.add('btn--loading');
      this.checkoutBtn.style.opacity = '0.6';
      return;
    }

    this.checkoutBtn.classList.remove('btn--loading');

    if (state === 'enabled') {
      this.checkoutBtn.disabled = false;
      this.checkoutBtn.style.opacity = '';
      if (textEl) textEl.textContent = label || 'Checkout';
    } else {
      this.checkoutBtn.disabled = true;
      this.checkoutBtn.style.opacity = '0.6';
      if (textEl && label) textEl.textContent = label;
    }
  }

  async setCheckoutState() {
    if (!this.checkoutBtn) return;

    // Show spinner while syncing with Shopify
    if (this._syncing) {
      this.setCheckoutDisplay('loading');
      return;
    }

    const method = this.getSelectedMethod();
    const frozenWeight = this.getFrozenWeight();

    if (!method) {
      this.setCheckoutDisplay('disabled', 'Select Delivery Method');
      return;
    }

    if (method === 'Local Route Delivery') {
      const valid = !!(this.routeSelect?.value && this.stopSelect?.value && this.dateSelect?.value);
      if (this.routeMessage) this.routeMessage.hidden = valid;
      this.updateRouteDetailsInline();

      if (valid) {
        this.setCheckoutDisplay('loading');
        await this.updateRouteDeliveryProperties();
        this.setCheckoutDisplay('enabled');
      } else {
        this.setCheckoutDisplay('disabled', 'Complete Route Details');
      }
      return;
    }

    if (method === 'Bundle with Existing Order') {
      const orderNum = this.bundleOrderInput?.value?.trim() || '';
      const email = this.bundleEmailInput?.value?.trim() || '';
      const emailValid = this.isValidEmail(email);
      const valid = orderNum.length > 0 && emailValid;
      if (this.bundleMessage) this.bundleMessage.hidden = valid;
      if (valid) {
        this.setCheckoutDisplay('enabled');
      } else if (email.length > 0 && !emailValid) {
        this.setCheckoutDisplay('disabled', 'Enter a Valid Email');
      } else {
        this.setCheckoutDisplay('disabled', 'Complete Bundle Details');
      }
      return;
    }

    if (method === 'Shipping' && this.hasFrozenItems() && frozenWeight < this.FROZEN_MIN_WEIGHT) {
      this.setCheckoutDisplay('disabled', 'Min. 20 lbs Frozen Required');
      return;
    }

    this.updateRouteDetailsInline();
    this.setCheckoutDisplay('enabled');
    if (this.routeMessage) this.routeMessage.hidden = true;
  }

  updateRouteDetailsInline() {
    if (!this.routeDetailsInline) return;

    const method = this.getSelectedMethod();
    if (method !== 'Local Route Delivery') return;

    const route = this.routeSelect?.value || '';
    const stop = this.stopSelect?.value || '';
    const date = this.dateSelect?.value || '';

    if (route && stop && date) {
      if (this.routeDetailsTitle) this.routeDetailsTitle.textContent = 'Route Details';
      if (this.routeDetailsContainer) this.routeDetailsContainer.classList.remove('route-details-inline--warning');
      this.routeDetailsInline.innerHTML =
        `<span><strong>Route:</strong> ${route}</span><br>` +
        `<span><strong>Stop:</strong> ${stop}</span><br>` +
        `<span><strong>Date:</strong> ${this.formatDate(date)}</span>`;
    } else {
      if (this.routeDetailsTitle) this.routeDetailsTitle.textContent = 'Route Details Needed';
      if (this.routeDetailsContainer) this.routeDetailsContainer.classList.add('route-details-inline--warning');
      this.routeDetailsInline.textContent = 'Please use the Select a Route form to add route details to your order \u2014 required to checkout.';
    }
  }

  /* ========================================================
     EVENT HANDLERS
  ======================================================== */

  async handleMethodChange(event) {
    const method = event.target.value;

    // Step 1: Immediately update all visual elements (synchronous, no await)
    // Hide outgoing, show incoming — the banner is informational and doesn't need sync
    this.routeFields.classList.add('route-fields--collapsed');
    this.bundleFields?.classList.add('bundle-fields--collapsed');
    if (method === 'Shipping') {
      this.showTrackerIfNeeded();
    } else {
      this.hideTracker();
    }

    // Step 2: Set up the incoming method's UI and write cart attributes
    if (method === 'Local Route Delivery') {
      this.routeFields.classList.remove('route-fields--collapsed');

      if (this._cachedRouteSelection) {
        this.restoreCachedRouteSelection();

        await this.updateCartAttributes({
          'Delivery Method': this.getDeliveryMethodAttributeValue(),
          'Delivery Route': this._cachedRouteSelection.route,
          'Delivery Stop': this._cachedRouteSelection.stop,
          'Delivery Date': this._cachedRouteSelection.date,
          'Bundle Order Number': '',
          'Bundle Order Email': '',
        });
      } else {
        this.clearRouteFields();
        await this.updateCartAttributes({
          'Delivery Method': this.getDeliveryMethodAttributeValue(),
          'Delivery Route': '',
          'Delivery Stop': '',
          'Delivery Date': '',
          'Bundle Order Number': '',
          'Bundle Order Email': '',
        });
      }
    } else if (method === 'Bundle with Existing Order') {
      this.bundleFields?.classList.remove('bundle-fields--collapsed');
      this.cacheRouteSelection();
      this.clearRouteFields();

      await this.updateCartAttributes({
        'Delivery Method': this.getDeliveryMethodAttributeValue(),
        'Delivery Route': '',
        'Delivery Stop': '',
        'Delivery Date': '',
        'Bundle Order Number': this.bundleOrderInput?.value?.trim() || '',
        'Bundle Order Email': this.bundleEmailInput?.value?.trim() || '',
      });
    } else {
      this.cacheRouteSelection();
      this.clearRouteFields();

      await this.updateCartAttributes({
        'Delivery Method': this.getDeliveryMethodAttributeValue(),
        'Delivery Route': '',
        'Delivery Stop': '',
        'Delivery Date': '',
        'Bundle Order Number': '',
        'Bundle Order Email': '',
      });
    }

    // Step 3: Sync with Shopify — show spinners only during method switches
    await this.runSyncsAndRefresh({ showLoading: true });
  }

  async handleRouteChange() {
    const selectedRoute = this.routes.find((route) => route.name === this.routeSelect.value);

    // Reset stop/date options without hiding the fields
    this.stopSelect.innerHTML = '<option value="">Choose a stop</option>';
    this.dateSelect.innerHTML = '<option value="">Choose a date</option>';
    this.updateReflections();

    // Route color changed — update properties with new route (stop/date now empty)
    await this.updateRouteDeliveryProperties();

    if (!selectedRoute) {
      this.stopWrap.hidden = true;
      this.dateWrap.hidden = true;
      this.updateRouteDescription(null);
      await this.setCheckoutState();
      return;
    }

    this.updateRouteDescription(selectedRoute);

    (selectedRoute.stops || []).forEach((stop) => {
      const option = document.createElement('option');
      option.value = stop.label;
      option.textContent = stop.label;
      this.stopSelect.appendChild(option);
    });

    this.filterFutureDates(selectedRoute.dates).forEach((date) => {
      const option = document.createElement('option');
      option.value = date;
      option.textContent = this.formatDate(date);
      this.dateSelect.appendChild(option);
    });

    this.stopWrap.hidden = false;
    this.dateWrap.hidden = false;

    this._cachedRouteSelection = {
      route: this.routeSelect.value,
      stop: '',
      date: '',
    };

    await this.setCheckoutState();
  }

  async handleRouteStopDateChange() {
    await this.updateCartAttributes({
      'Delivery Method': 'Local Route Delivery',
      'Delivery Route': this.routeSelect?.value || '',
      'Delivery Stop': this.stopSelect?.value || '',
      'Delivery Date': this.dateSelect?.value || '',
    });

    // Always write current selections to the line item (even partial)
    await this.updateRouteDeliveryProperties();

    this._cachedRouteSelection = {
      route: this.routeSelect?.value || '',
      stop: this.stopSelect?.value || '',
      date: this.dateSelect?.value || '',
    };

    this.updateReflections();
    await this.setCheckoutState();
  }

  async handleBundleFieldChange() {
    await this.updateCartAttributes({
      'Delivery Method': 'Bundle with Existing Order',
      'Bundle Order Number': this.bundleOrderInput?.value?.trim() || '',
      'Bundle Order Email': this.bundleEmailInput?.value?.trim() || '',
    });
    await this.setCheckoutState();
  }

  async handleSubmit(event) {
    const method = this.getSelectedMethod();
    const frozenWeight = this.getFrozenWeight();

    if (!method || this._syncing) {
      event.preventDefault();
      return;
    }

    if (method === 'Store Pickup') {
      event.preventDefault();
      window.location.href = this.buildCheckoutUrlWithShippingAddress(this.STORE_PICKUP_ADDRESS);
      return;
    }

    if (method === 'Shipping' && this.hasFrozenItems() && frozenWeight < this.FROZEN_MIN_WEIGHT) {
      event.preventDefault();
      alert('Frozen shipping requires a minimum of 20 lbs.');
      return;
    }

    if (method === 'Local Route Delivery') {
      const valid = !!(this.routeSelect?.value && this.stopSelect?.value && this.dateSelect?.value);
      if (!valid) {
        event.preventDefault();
        this.setCheckoutState();
        return;
      }

      const stop = this.getSelectedStop();
      if (stop) {
        event.preventDefault();
        let company = `${this.routeSelect?.value || ''} Route Delivery - Stop ${stop.stopNumber}`;
        if (stop.time) {
          company += ` @ ${stop.time}${stop.timezone ? ' ' + stop.timezone : ''}`;
        }
        window.location.href = this.buildCheckoutUrlWithShippingAddress({
          company: company,
          address1: stop.address1,
          address2: stop.address2,
          city: stop.city,
          province: stop.province,
          country: 'United States',
          zip: stop.zip,
        });
      }
      return;
    }

    if (method === 'Bundle with Existing Order') {
      const orderNum = this.bundleOrderInput?.value?.trim() || '';
      const email = this.bundleEmailInput?.value?.trim() || '';
      if (!orderNum || !this.isValidEmail(email)) {
        event.preventDefault();
        this.setCheckoutState();
        return;
      }

      event.preventDefault();
      const bundleAddress = {
        ...this.STORE_PICKUP_ADDRESS,
        company: `Bundle Order ${orderNum}`,
      };
      window.location.href = this.buildCheckoutUrlWithShippingAddress(bundleAddress);
      return;
    }
  }
}

/* ========================================================
   INITIALIZATION
======================================================== */

function initCustomCartFulfillment() {
  if (CustomCartFulfillment.instance) {
    CustomCartFulfillment.instance.refresh();
  } else {
    new CustomCartFulfillment(document);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initCustomCartFulfillment();
});

document.addEventListener('cart:updated', () => {
  initCustomCartFulfillment();
});
/* END - Logic for Cart Delivery Options */
